export default "__VITE_ASSET__Cnn1JDw2__"